module["exports"] = [
  "BV",
  "V.O.F.",
  "Group",
  "en Zonen"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/company/suffix.js
// module id = 1563
// module chunks = 1